export const MessageMeta = {
    /**
     * [[Collab.getContext]] key with value type [[MessageMeta]] that returns
     * the next [[MessageMeta]] for a locally echoed message, or
     * undefined if the next [[MessageMeta]] is just the default
     * `{ sender: (local replicaID), isLocalEcho: true }`
     *
     * The next [[MessageMeta]] will be passed along with
     * the locally echoed message corresponding to the next
     * [[ICollabParent.childSend]]
     * call, assuming there are no intervening messages
     * that change the [[MessageMeta]]
     * (within the whole [[Runtime]]). This can be used by children
     * to get the [[MessageMeta]] for messages that they echo internally.
     *
     * If [[Collab.getContext]] returns undefined (no ancestor
     * supplied the [[MessageMeta]]).
     *
     * A Collab that adds extra metadata to [[MessageMeta]]
     * (via the index signature) generally should define
     * this key in [[ICollabParent.getAddedContext]],
     * so that descendants' [[Collab.getContext]] calls
     * return the correct [[MessageMeta]]. An exception is if
     * you know descendants will ignore locally echoed messages,
     * in which case it does not matter.
     */
    NEXT_MESSAGE_META: Symbol(),
};
//# sourceMappingURL=message_meta.js.map